<script setup>
import Upload from '@/components/upload/upload.vue'
import { nextTick, ref, toValue } from 'vue'
import { useApi } from '@provise/composables/api.js'

const model = defineModel({})
const emit = defineEmits(['done'])

const replyUploadUrl = ref(null)
const fileUploadModel = ref([])
const doc = ref({})
const fileUploader = ref(null)
const { refresh: createReply } = useApi({
  url: `complaints/${model.value.id}/reply`,
  method: 'post',
  model: doc,
})
async function uploadFile() {
  doc.value = {}
  await createReply()
  replyUploadUrl.value = `complaints/${model.value.id}/reply/${doc.value.id}/upload`
  await nextTick()
  await fileUploader.value.upload()
  emit('done', toValue(doc))
  doc.value = {}
  fileUploadModel.value = []
}
</script>
<template>
  <Upload
    #="{ choose }"
    :url="replyUploadUrl"
    :delayed="true"
    division="complaint.reply"
    @upload:chosen="uploadFile"
    v-model="fileUploadModel"
    ref="fileUploader"
  >
    <button type="button" class="btn btn-light" @click="choose">
      <i class="bi bi-file-earmark" />
      Загрузить файл
    </button>
  </Upload>
</template>
